// types

// project import
import { HasAuthFunc } from '@/auth-capabilities';
import { cn } from '@/components/ui';
import { useNavbarMenuItems } from '@/layout/NavbarMenuItems';
import { useMenuBar } from '@/services/MenuBarService';
import { NavItemType } from '@/types/menu';

import NavGroup from './NavGroup';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export const Navigation = () => {
  const drawerOpen = useMenuBar(state => state.drawerOpen);
  const navbarMenuItems = useNavbarMenuItems();

  const navGroups = navbarMenuItems.items.map(item => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <p key={item.id} className="px-3 py-2 text-center text-xs text-critical">
            Fix - Navigation Group
          </p>
        );
    }
  });

  // Open uses the original px-3 gutter so nested queue rows line up under "Queue".
  // Collapsed drops horizontal padding so the mini-rail icon column fills the clip.
  return <nav className={cn('pb-4 pt-2', drawerOpen ? 'px-3' : 'px-0')}>{navGroups}</nav>;
};

export function navItemCheckAuth(item: NavItemType, hasAuth: HasAuthFunc): boolean {
  if (!item.auth) {
    return true;
  }
  return hasAuth(item.auth);
}
